
    import { Component, Vue } from 'vue-property-decorator'
    import appBar from '@/components/AppBar.vue'

    @Component({
        components: { appBar }
    })
    export default class Menu extends Vue {
        //#region
        private clickInpt() {
            var workingDate = new Date().toISOString().substr(0, 10)
            this.$router.push({ name: 'AttendanceEntry', params: { workingDate: workingDate } })
        }
        //#endregion
    }
